import { render, staticRenderFns } from "./AverageDay.vue?vue&type=template&id=4d191c06&scoped=true&"
import script from "./AverageDay.vue?vue&type=script&lang=ts&"
export * from "./AverageDay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d191c06",
  null
  
)

export default component.exports